// Session patient stockée en sessionStorage — EXTRAITE de PatientAuthContext.
//
// `lib/hook/tanstackQuery.ts` (importé par TOUT le front) a besoin de lire cette session
// pour router le token patient. L'importer depuis PatientAuthContext créait un cycle
// tanstackQuery ↔ PatientAuthContext (le contexte consomme useRestMutation) qui tirait le
// module patient dans chaque consommateur de la couche REST et re-compilait l'ensemble au
// moindre changement en dev. Ce fichier ne doit importer AUCUN hook ni composant.

const SESSION_STORAGE_KEY = 'patient_session'

export type PatientDossier = {
  dossierId: number
  companyId: number
  companyName: string
  companyCity: string | null
  token: string
  fcLinked?: boolean
  firstname?: string | null
  lastnameInitial?: string | null
}

export type PatientSession = {
  dossiers: PatientDossier[]
  activeDossierId: number | null
  isAuthenticated: boolean
  loggedViaFc?: boolean
}

export const getStoredSessionPatient = (): PatientSession | null => {
  if (typeof window === 'undefined') return null
  try {
    const stored = sessionStorage.getItem(SESSION_STORAGE_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

export const storeSessionPatient = (session: PatientSession | null) => {
  if (typeof window === 'undefined') return
  if (session) {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session))
  } else {
    sessionStorage.removeItem(SESSION_STORAGE_KEY)
  }
}
